import { useEffect, useState } from "react";

export const LOGO_SRC = "/brand/logo-dark.png";
export const LOGO_LIGHT_SRC = "/brand/logo-light.png";
export const LOGO_RATIO = 846 / 168;
const urls = {}, pending = {};
const subs = new Set();

export function loadLogo(src = LOGO_SRC) {
  if (urls[src]) return Promise.resolve(urls[src]);
  if (!pending[src]) {
    pending[src] = fetch(src).then((r) => r.blob()).then((b) => new Promise((res) => {
      const fr = new FileReader();
      fr.onload = () => { urls[src] = fr.result; subs.forEach((f) => f({ ...urls })); res(fr.result); };
      fr.readAsDataURL(b);
    }));
  }
  return pending[src];
}

export function useLogo(src = LOGO_SRC) {
  const [v, setV] = useState(urls);
  useEffect(() => {
    subs.add(setV);
    loadLogo(src).catch(() => {});
    return () => { subs.delete(setV); };
  }, [src]);
  return v[src] || src;
}

let vector = null;
export const loadLogoVector = () => {
  if (!vector) vector = fetch("/brand/logo-vector.json").then((r) => r.json()).catch((e) => { vector = null; throw e; });
  return vector;
};
